import { SuiteApiClient } from "@weco/suite-client";

// Empty baseUrl: every adapter calls absolute, same-origin paths (vite-suite-proxy
// routes them to the right satellite in dev; satellite domain in prod).
let _searchClient: SuiteApiClient | null = null;

/** Lazily constructed so importing this module (or the suite-chrome barrel)
 * never instantiates a SuiteApiClient at module-eval time. */
export function getSearchClient(): SuiteApiClient {
  return (_searchClient ??= new SuiteApiClient(""));
}
